module.exports = __webpack_public_path__ + "img/CanZheng.fb1d95d4.jpg";